import React from 'react';
import { observer } from 'mobx-react-lite';
import { QueueSearchInput } from './queue-search-input';
import { getQueueTitle } from '../utils/get-queue-title';
import { useQueueStore } from '../context/use-queue-store';
import { Flex, HStack, Box } from '@cad-arc';
import { QueueGroupByMenu } from './queue-group-by-menu';
import { EventQueueRowData } from '../../socket/stream-types';
import { useEventNotificationsStore } from '../../event-notifications/use-event-notifications';
import { getEventQueueRowData } from '../utils/get-event-queue-row-data';
import { UnitQueueStore } from '../../unit-queues/store/unit-queue-store';
import { QueueOtherOptionsMenu } from './queue-other-options-menu';
import { UnitTypeFilterPopover } from '../../unit-queues/components/unit-queue-filter-popover';
import { PanelTitle } from '../../panels/panel-title';
import { EventNotificationsCounter } from '../../event-panel/tabs/components/event-notifications-counter';
import { HospitalAttributeFilterPopover } from '../../hospital-queues/components/hospital-attribute-filter-popover';
import { EventQueueFilterPopover } from '../../event-queues/components/cells/event-queue-filter-popover';

export const QueueHeader = observer(function QueueHeader({
    onEditColumns,
}: {
    onEditColumns: () => void;
}): React.ReactElement {
    const store = useQueueStore() as UnitQueueStore;
    const eventNotificationsStore = useEventNotificationsStore();

    const allEventNotificationsForQueue = store.listStore.data.list
        .map((eventQueueRowData: EventQueueRowData) => {
            const eventId = getEventQueueRowData(eventQueueRowData)?.id;
            if (eventId) {
                return eventNotificationsStore.getAllNotificationsForEvent(eventId);
            } else {
                return [];
            }
        })
        .flat();

    const queueTitle = getQueueTitle(
        store.workspacePanel.queue.dataEntityType,
        store.workspacePanel.queue.queueClasses,
        store.workspacePanel.queue.assignmentStatus,
        store.workspacePanel.queue.eventQueue
    );

    return (
        <Flex
            style={{ gap: '10px' }}
            alignItems="center"
            justifyContent="space-between"
            width="100%"
        >
            <HStack alignItems="center" flexShrink={1}>
                {store.workspacePanel.queue.showUpdates ? (
                    <EventNotificationsCounter notifications={allEventNotificationsForQueue} />
                ) : undefined}
                <PanelTitle>{queueTitle}</PanelTitle>
                <Box maxWidth="222px">
                    <QueueSearchInput />
                </Box>
            </HStack>
            <HStack alignItems="center" flexShrink={0}>
                <Box>
                    <QueueGroupByMenu />
                    <QueueOtherOptionsMenu onEditColumns={onEditColumns} />
                    {store.workspacePanel.queue.dataEntityType === 'UNIT' && (
                        <UnitTypeFilterPopover />
                    )}
                    {store.workspacePanel.queue.dataEntityType === 'HOSPITAL' && (
                        <HospitalAttributeFilterPopover />
                    )}
                    {store.workspacePanel.queue.dataEntityType === 'CAD_AGENCY_EVENT' && (
                        <EventQueueFilterPopover />
                    )}
                </Box>
            </HStack>
        </Flex>
    );
});
